import WSService from "../../web-socket/web-socket-service";
import { api } from "../api/callApi";
import { urlServer } from "../api/v1";
import { IActivityLog, IChecklist, TOperation2 } from "../varibles/interface";

const urlBase = urlServer + '/vessel-side';

interface IGetDashboardOfVesselSide {
    vessels: string[]
}

interface IUpdateStateOpOfVesselSide {
    operation_id: string
    tenant_id?: string
    vessel_id?: string
    checklists_v2: IChecklist[]
    group_ids?: string[]
}

interface IUpdateStatusOpOfVesselSide {
    operation_id: string
    tenant_id?: string
    status: string
}

interface IUpdateTimeStepVesselSide {
    operation_id: string
    tenant_id: string
    time: number
    index: number
}

interface ICrewSend {
    vessels: {
        vessel_id: string
        operations: any[]
    }[]
}

interface IOrderUnits {
    operation_id: string
    tenant_id: string
    unit_order: {
        unit_id: string,
        id: string
    }[]
}

interface IUpdateChecklist {
    operation_id: string
    tenant_id: string
    checklists_v2: IChecklist[]
}

export const VesselSideService = {
    dashboard: (body: IGetDashboardOfVesselSide, abort?: AbortController) => {
        const connection_id = WSService.getConnectId();
        return api.post(urlBase + '/dashboard', { ...body, connection_id }, { signal: abort?.signal })
    },
    updateState: (body: IUpdateStateOpOfVesselSide, abort?: AbortController) => {
        const connection_id = WSService.getConnectId();
        return api.put<{ operation: TOperation2, activity_log: IActivityLog[] }>(urlBase + '/update/state', {
            ...body,
            time: Date.now(),
            timezone: Math.floor(new Date().getTimezoneOffset() / 60) * -1,
            connection_id
        }, { signal: abort?.signal })
    },
    updateChecklist: (body: IUpdateChecklist, abort?: AbortController) => {
        const connection_id = WSService.getConnectId();
        return api.put<IChecklist[]>(urlBase + '/update/checklist', {
            ...body,
            time: Date.now(),
            timezone: Math.floor(new Date().getTimezoneOffset() / 60) * -1,
            connection_id
        }, { signal: abort?.signal })
    },
    updateStatus: (body: IUpdateStatusOpOfVesselSide) => {
        const connection_id = WSService.getConnectId();
        return api.put(urlBase + '/update/status', { ...body, connection_id })
    },
    updateTimeStep: (body: IUpdateTimeStepVesselSide, abort?: AbortController) => {
        const connection_id = WSService.getConnectId();
        return api.put(urlBase + '/edit/state', { ...body, connection_id }, { signal: abort?.signal })
    },
    crewSend: (body: ICrewSend, abort?: AbortController) => {
        const connection_id = WSService.getConnectId();
        return api.post(urlBase + '/confirm', { ...body, connection_id }, { signal: abort?.signal })
    },
    orderUnits: (body: IOrderUnits, abort?: AbortController) => {
        const connection_id = WSService.getConnectId();
        return api.put(urlBase + '/order', { ...body, connection_id }, { signal: abort?.signal })
    }
}
